import { PlatformType } from '../../types/authorization'

export const REPORT_SUPPORT_DOCUMENTATION_URL =
  'https://support.dashboardinsights.com/en/articles/10161033-dashboard-insights-reporting-feature'

export const PLATFORM_TYPE_OPTIONS = [
  { value: PlatformType.Xero, label: 'Xero' },
  { value: PlatformType.XeroXpm, label: 'XPM' },
  { value: PlatformType.XeroWorkflowMax, label: 'Xero Workflow Max' },
  { value: PlatformType.Myob, label: 'MYOB' },
  { value: PlatformType.WorkGuru, label: 'WorkGuru' },
  { value: PlatformType.BRWFM, label: 'Bluerock Workflow Max' },
  { value: PlatformType.Karbon, label: 'Karbon' },
  { value: PlatformType.FYI, label: 'FYI' },
  { value: PlatformType.QuickBooks, label: 'QuickBooks' },
]

export function getPlatformTypeLabel(platformType?: number | null) {
  if (!platformType) return '-'
  return PLATFORM_TYPE_OPTIONS.find((option) => option.value === platformType)?.label || String(platformType)
}
